import React from 'react';
import './Navbar.css';

const Navbar = ({ currentMonth, onMonthChange, currentYear, onYearChange, onPrint, monthName, currentView, onViewChange }) => {
  const MONTHS = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  // Generar años desde 2020 hasta 2030
  const currentYearNum = new Date().getFullYear();
  const years = [];
  for (let year = 2020; year <= 2030; year++) {
    years.push(year);
  }

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <div className="navbar-brand">
          <span className="brand-icon">✈️</span>
          <span className="brand-text">
            <span className="brand-name">Juan Sepúlveda </span>
            <span className="brand-app">Planificador</span>
          </span>
        </div>

        <div className="navbar-navigation">
          {currentView === 'months' ? (
            <>
              <div className="year-selector-wrapper">
                <select 
                  className="year-select"
                  value={currentYear}
                  onChange={(e) => onYearChange(parseInt(e.target.value))}
                >
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>

              <button 
                className="nav-arrow-btn"
                onClick={() => onMonthChange(currentMonth === 0 ? 11 : currentMonth - 1)}
                aria-label="Mes anterior"
              >
                ←
              </button>
              
              <div className="month-selector">
                <select 
                  className="month-select"
                  value={currentMonth}
                  onChange={(e) => onMonthChange(parseInt(e.target.value))}
                >
                  {MONTHS.map((month, index) => (
                    <option key={index} value={index}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>

              <button 
                className="nav-arrow-btn"
                onClick={() => onMonthChange(currentMonth === 11 ? 0 : currentMonth + 1)}
                aria-label="Mes siguiente"
              >
                →
              </button>
            </>
          ) : (
            <div className="year-selector-wrapper">
              <select 
                className="year-select"
                value={currentYear}
                onChange={(e) => onYearChange(parseInt(e.target.value))}
              >
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className="navbar-actions">
          <button 
            className={`view-toggle-btn ${currentView === 'year' ? 'active' : ''}`}
            onClick={() => onViewChange('year')}
            title="Vista Anual"
          >
            <span>📅</span>
            <span>Año</span>
          </button>
          <button 
            className={`view-toggle-btn ${currentView === 'dashboard' ? 'active' : ''}`}
            onClick={() => onViewChange('dashboard')}
            title="Dashboard"
          >
            <span>📊</span>
            <span>Dashboard</span>
          </button>
          <button 
            className={`view-toggle-btn ${currentView === 'comparison' ? 'active' : ''}`}
            onClick={() => onViewChange('comparison')}
            title="Comparar Años"
          >
            <span>📈</span>
            <span>Comparar</span>
          </button>
          <button 
            className={`view-toggle-btn ${currentView === 'overall' ? 'active' : ''}`}
            onClick={() => onViewChange('overall')}
            title="Dashboard General"
          >
            <span>🌐</span>
            <span>General</span>
          </button>
          {currentView === 'months' && (
            <button className="print-nav-btn" onClick={onPrint}>
              <span>🖨️</span>
              <span>Imprimir</span>
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

